function plusMinus(e) {
    const qytInput = document.querySelectorAll('.input-text.qty')

    qytInput.forEach((input) => {
        let qty = parseInt(input.value)

        if (e.target.matches('.plus')) {
            input.value = qty + 1
        } else if (e.target.matches('.minus') && qty > 1) {
            input.value = qty - 1
        }
    })
}

document.addEventListener('click', function (e) {
    if (e.target.matches('.plusminus')) {
        plusMinus(e)
    }
})

// Unfournately WooCommerce uses jQuery so we need to use it here too
;(function ($) {
    $(document.body).on('adding_to_cart', function () {
        document.body.classList.add('cart-loading')
    })

    // $(document.body).on('applied_coupon_in_checkout', function () {
    // if (noticesWrapper.childElementCount > 1) {
    //     document.body.classList.add('show-notice')
    // } else {
    //     document.body.classList.remove('show-notice')
    // }
    // })

    $(document.body).on('added_to_cart', function () {
        document.body.classList.remove('cart-loading')
        document.body.classList.add('cart-added')

        setTimeout(() => {
            document.body.classList.remove('cart-added')
        }, 500)
    })

    $(document).on('click', '.single_add_to_cart_button, .add_to_cart_button', function (e) {
        e.preventDefault()

        var addToCartBtn = $(this),
            form = addToCartBtn.closest('form.cart'),
            id = addToCartBtn.val(),
            productQty = form.find('input[name=quantity]').val() || 1,
            productId = form.find('input[name=product_id]').val() || id,
            variationId = form.find('input[name=variation_id]').val() || 0

        var ajaxData = {
            action: 'add_to_cart',
            security: tlGlobal.addToCart,
            product_id: productId,
            product_sku: '',
            quantity: productQty,
            variation_id: variationId,
        }

        $(document.body).trigger('adding_to_cart', [addToCartBtn, ajaxData])

        if (addToCartBtn[0].classList.contains('add_to_cart_button')) {
            const price = addToCartBtn[0].dataset.price
            fbq('track', 'AddToCart', {
                content_ids: [addToCartBtn[0].dataset.product_id],
                content_type: 'product',
                value: addToCartBtn[0].dataset.price,
                currency: 'SEK',
            })
        } else {
            const price = addToCartBtn[0].dataset.price
            fbq('track', 'AddToCart', {
                content_ids: [productId],
                content_type: 'product',
                value: price,
                currency: 'SEK',
            })
        }

        $.ajax({
            type: 'post',
            url: tlGlobal.adminUrl,
            data: ajaxData,

            beforeSend(response) {
                document.body.classList.add('cart-loading')
                addToCartBtn[0].classList.add('btn-loading')
            },
            success(response, statusTxt) {
                $(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, addToCartBtn])
                document.body.classList.remove('cart-loading')
                document.body.classList.add('cart-added')
                addToCartBtn[0].classList.remove('btn-loading')
                addToCartBtn[0].classList.add('btn-added')

                if (statusTxt === 'success') {
                    setTimeout(() => {
                        document.body.classList.remove('cart-added')
                        addToCartBtn[0].classList.remove('btn-added')
                        // addToCartBtn.removeClass('added')
                    }, 500)
                }
            },
            error(error) {
                console.log('error', error)
            },
        })

        return false
    })
})(jQuery)

// Show element if element is not in veiwport
function showAddToCartOnScroll(elementToWatch, elementToShow) {
    elementToWatch = document.querySelector('.product-summary-cta')
    const buyNotice = document.querySelector('.buy-notice')
    if (!elementToWatch) {
        return
    }
    elementToShow = document.querySelector('.add-to-cart-wrapper')

    const rect = elementToWatch.getBoundingClientRect()
    const windowHeight = window.innerHeight || document.documentElement.clientHeight
    const windowWidth = window.innerWidth || document.documentElement.clientWidth
    const windowTop = window.pageYOffset || document.documentElement.scrollTop
    const windowBottom = windowTop + windowHeight
    const windowLeft = window.pageXOffset || document.documentElement.scrollLeft
    const windowRight = windowLeft + windowWidth
    const top = rect.top + windowTop
    const bottom = rect.bottom + windowTop
    const left = rect.left + windowLeft
    const right = rect.right + windowLeft

    if (top < windowBottom && bottom > windowTop && left < windowRight && right > windowLeft) {
        elementToShow.classList.remove('show', 'display')
        if (buyNotice) {
            buyNotice.style.bottom = '24px'
        }
    } else {
        if (buyNotice) {
            buyNotice.style.bottom = '90px'
        }
        elementToShow.classList.add('display')

        setTimeout(() => {
            elementToShow.classList.add('show')
        }, 100)
    }
}

document.addEventListener('scroll', showAddToCartOnScroll)
